"use client";

import { useEffect } from "react";

export default function CaptureClickId() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const params = [
        "click_id",
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "campaign_id",
        "utm_term",
        "utm_content",
        "adgroup_id",
        "ad_id",
        "keyword",
        "matchtype",
        "device",
        "network",
      ];

      params.forEach(param => {
        const value = urlParams.get(param);
        if (value) localStorage.setItem(param, value);
      });
    }
  }, []);

  return null; // No UI needed, just logic
}
